export default __webpack_public_path__ + "static/media/savouryBiscuits.19084404.jpeg";